
<template>
  <div id="page-content-add">

    <vx-card title="컨텐츠 추가" class="mb-base" >

      <content-filter class="mt-4" 
        @onMenuChanged="onMenuChanged"
        @onBookCodeChanged="onBookCodeChanged" 
        @onUnitChanged="onUnitChanged"
        @onStepCodeChanged="onStepCodeChanged"/>

      <vx-card title="컨텐츠 복사" class="mb-base" >
        <div class="vx-row">
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <vs-select class="mb-4 w-full" v-model="content" name="item-unit-content">
              <vs-select-item :key="item.studyContentSeq" :value="item" :text="item.menuName + ' (' + item.contentCode + ')'" v-for="item in unitContentList" />
            </vs-select>
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <vs-button @click="copyContent">컨텐츠 복사</vs-button>
          </div>
        </div>
      </vx-card>

      <listening-sound-form v-if="menuCode === 'L010'"  class="mt-4" 
        @onDataChanged="onDataChanged" :source-content="sourceContent" />

      <listening-with-pictures-form v-if="menuCode === 'L020'"  class="mt-4" 
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <listening-with-subtitles-form v-if="menuCode === 'L030'"  class="mt-4" 
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <listening-korean-form v-if="menuCode === 'L040'"  class="mt-4" 
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <listening-words-form v-if="menuCode === 'V010'"  class="mt-4" 
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <listening-words-form-v08 v-if="menuCode === 'V080'"  class="mt-4" 
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <speaking-words-form v-if="menuCode === 'V020'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <words-dictation1-form v-if="menuCode === 'V030'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <words-dictation2-form v-if="menuCode === 'V031'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <words-dictation3-form v-if="menuCode === 'V032'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <writing-words-form v-if="menuCode === 'V040'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <checking-words-form v-if="menuCode === 'V050'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <intonation-reading-form v-if="menuCode === 'R020'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <speed-reading1-form v-if="menuCode === 'R030'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <speed-reading2-form v-if="menuCode === 'R031'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <reading-and-translating-form v-if="menuCode === 'R040'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <shadow-readings-form v-if="menuCode === 'R060'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <listen-and-fill-in-Form v-if="menuCode === 'L070'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <sentence-dictation-type1-form v-if="menuCode === 'L080'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <sentence-dictation-type2-form v-if="menuCode === 'L081'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <sentence-speaking-form v-if="menuCode === 'S010'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <role-play-form v-if="menuCode === 'S020'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <speak-straight1-form v-if="menuCode === 'S030'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <speak-straight2-form v-if="menuCode === 'S031'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <pattern-practice-form v-if="menuCode === 'S050'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <matching-sentences-form v-if="menuCode === 'W010'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <writing-blank-type1-form v-if="menuCode === 'W020'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <writing-blank-type2-form v-if="menuCode === 'W021'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <writing-blank-type3-form v-if="menuCode === 'W022'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <writing-blank-type4-form v-if="menuCode === 'W023'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <writing-composition-form v-if="menuCode === 'W030'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <reading-and-speaking-form v-if="menuCode === 'R050'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>

      <listening-phonics1-form v-if="menuCode === 'P050'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <listening-phonics2-form v-if="menuCode === 'P060'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <speaking-phonics1-form v-if="menuCode === 'P070'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <speaking-phonics2-form v-if="menuCode === 'P080'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <matching-phonics1-form v-if="menuCode === 'P090'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <matching-phonics2-form v-if="menuCode === 'P100'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <writing-phonics1-form v-if="menuCode === 'P110'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <writing-phonics2-form v-if="menuCode === 'P120'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <pattern-extension1-form v-if="menuCode === 'S060'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <pattern-extension2-form v-if="menuCode === 'S061'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <pattern-extension3-form v-if="menuCode === 'S062'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <listening-phonics-form v-if="menuCode === 'P010'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <speaking-phonics-form v-if="menuCode === 'P020'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <matching-phonics-form v-if="menuCode === 'P030'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <writing-phonics-form v-if="menuCode === 'P040'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>        

      <memorizing-words1-form v-if="menuCode === 'V070'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>   

      <memorizing-words2-form v-if="menuCode === 'V071'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>   

      <grammar-explanation-form v-if="menuCode === 'G010'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>  

      <check-up-form v-if="menuCode === 'C010'"  class="mt-4"
        @onDataChanged="onDataChanged" :source-content="sourceContent"/>  
    </vx-card>

  </div>
</template>

<script>
import { postData, fetchData } from '@/api/module'
import ContentFilter  from './ContentFilter'
import ListeningSoundForm  from './ListeningSoundForm'
import ListeningWithPicturesForm  from './ListeningWithPicturesForm'
import ListeningWithSubtitlesForm  from './ListeningWithSubtitlesForm'
import ListeningKoreanForm  from './ListeningKoreanForm'
import ListeningWordsForm  from './ListeningWordsForm'
import ListeningWordsFormV08  from './ListeningWordsFormV08'
import SpeakingWordsForm  from './SpeakingWordsForm'
import WordsDictation1Form  from './WordsDictation1Form'
import WordsDictation2Form  from './WordsDictation2Form'
import WordsDictation3Form  from './WordsDictation3Form'
import WritingWordsForm  from './WritingWordsForm'
import CheckingWordsForm  from './CheckingWordsForm'
import IntonationReadingForm  from './IntonationReadingForm'
import SpeedReading1Form  from './SpeedReading1Form'
import SpeedReading2Form  from './SpeedReading2Form'
import ReadingAndTranslatingForm  from './ReadingAndTranslatingForm'
import ListenAndFillInForm  from './ListenAndFillInForm'
import SentenceDictationType1Form  from './SentenceDictationType1Form'
import SentenceDictationType2Form  from './SentenceDictationType2Form'
import SentenceSpeakingForm  from './SentenceSpeakingForm'
import RolePlayForm  from './RolePlayForm'
import SpeakStraight1Form  from './SpeakStraight1Form'
import SpeakStraight2Form  from './SpeakStraight2Form'
import PatternPracticeForm  from './PatternPracticeForm'
import MatchingSentencesForm  from './MatchingSentencesForm'

import WritingBlankType1Form  from './WritingBlankType1Form'
import WritingBlankType2Form  from './WritingBlankType2Form'
import WritingBlankType3Form  from './WritingBlankType3Form'
import WritingBlankType4Form  from './WritingBlankType4Form'

import WritingCompositionForm  from './WritingCompositionForm'
import ReadingAndSpeakingForm  from './ReadingAndSpeakingForm'
import ListeningPhonics1Form  from './ListeningPhonics1Form'
import ListeningPhonics2Form  from './ListeningPhonics2Form'
import SpeakingPhonics1Form  from './SpeakingPhonics1Form'
import SpeakingPhonics2Form  from './SpeakingPhonics2Form'
import MatchingPhonics1Form  from './MatchingPhonics1Form'
import MatchingPhonics2Form  from './MatchingPhonics2Form'
import WritingPhonics1Form  from './WritingPhonics1Form'
import WritingPhonics2Form  from './WritingPhonics2Form'

import PatternExtension1Form  from './PatternExtension1Form'
import PatternExtension2Form  from './PatternExtension2Form'
import PatternExtension3Form  from './PatternExtension3Form'

import ShadowReadingsForm  from './ShadowReadingsForm'
import ListeningPhonicsForm  from './ListeningPhonicsForm'
import SpeakingPhonicsForm  from './SpeakingPhonicsForm'
import MatchingPhonicsForm  from './MatchingPhonicsForm'
import WritingPhonicsForm  from './WritingPhonicsForm'

import MemorizingWords1Form  from './MemorizingWords1Form'
import MemorizingWords2Form  from './MemorizingWords2Form'

import GrammarExplanationForm  from './GrammarExplanationForm'
import CheckUpForm  from './CheckUpForm'

const defaultContent = {studyContentSeq: '0', contentCode: '0', menuName:'없음'}

export default {
  components: {
    ContentFilter,
    ListeningSoundForm,
    ListeningWithPicturesForm,
    ListeningWithSubtitlesForm,
    ListeningKoreanForm,
    ListeningWordsForm,
    ListeningWordsFormV08,
    SpeakingWordsForm,
    WordsDictation1Form,
    WordsDictation2Form,
    WordsDictation3Form,
    WritingWordsForm,
    CheckingWordsForm,
    IntonationReadingForm,
    SpeedReading1Form,
    SpeedReading2Form,
    ReadingAndTranslatingForm,
    ListenAndFillInForm,
    SentenceDictationType1Form,
    SentenceDictationType2Form,
    SentenceSpeakingForm,
    RolePlayForm,
    SpeakStraight1Form,
    SpeakStraight2Form,
    PatternPracticeForm,
    MatchingSentencesForm,
    WritingBlankType1Form,
    WritingBlankType2Form,
    WritingBlankType3Form,
    WritingBlankType4Form,
    WritingCompositionForm,
    ReadingAndSpeakingForm,
    ListeningPhonics1Form,
    ListeningPhonics2Form,
    SpeakingPhonics1Form,
    SpeakingPhonics2Form,
    MatchingPhonics1Form,
    MatchingPhonics2Form,
    WritingPhonics1Form,
    WritingPhonics2Form,
    
    PatternExtension1Form,
    PatternExtension2Form,
    PatternExtension3Form,

    ShadowReadingsForm,
    ListeningPhonicsForm,
    SpeakingPhonicsForm,
    MatchingPhonicsForm,
    WritingPhonicsForm,
    MemorizingWords1Form,
    MemorizingWords2Form,
    GrammarExplanationForm,
    CheckUpForm
  },
  data () {
    return {
      menuCode: '',
      bookCode: '',
      unitCode: '',
      stepCode: '',
      bookInfo: {},
      unitContentList: [],
      content: defaultContent,
      sourceContent: null,
      stepList: []
    }
  },
  watch: {
    unitCode () {
      if (this.bookCode !== null && this.bookCode.length > 0) {
        this.loadUnitContents()
      }
    },
    bookCode () {
      if (this.unitCode !== null && this.unitCode.length > 0) {
        this.loadUnitContents()
      }
    }
  },
  methods: {
    onMenuChanged (val) {
      this.menuCode = val
    },
    onBookCodeChanged (val) {
      this.bookInfo = val
      this.bookCode = val.bookCode
    },
    onUnitChanged (val) {
      this.unitCode = val
    },
    onStepCodeChanged (val) {
      this.stepCode = val
    },
    copyContent () {
      this.sourceContent = this.content
    },
    async loadUnitContents () {
      try { 
        const { data } = await fetchData(`study-content/book/${this.bookCode}/unit/${this.unitCode}`)
        this.unitContentList = data.list
        if (this.unitContentList.length === 0) {
          this.unitContentList.push(defaultContent)
        }
        this.content = null

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async onDataChanged (val) {

      if (this.bookCode.length === 0) {
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '교재를 선택해 주세요.'
        })
        return
      }

      if (this.unitCode.length === 0) {
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '유닛 정보를 선택해 주세요.'
        })
        return
      }
      
      if (this.stepCode.length === 0) {
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '스텝 정보를 선택해 주세요.'
        })
        return
      }

      const formData = new FormData()
      formData.append('bookCode', this.bookCode)
      formData.append('unitCode', this.unitCode)
      formData.append('menuCode', this.menuCode)
      formData.append('stepCode', this.stepCode)
      
      if (val.hasOwnProperty('sentence')) {
        formData.append('sentence', JSON.stringify(val.sentence))
      }
      if (val.hasOwnProperty('translation')) {
        formData.append('translation', JSON.stringify(val.translation))
      }
      if (val.hasOwnProperty('dictation')) {
        formData.append('dictation', JSON.stringify(val.dictation))
      }
      if (val.hasOwnProperty('example')) {
        formData.append('example', JSON.stringify(val.example))
      }
      if (val.hasOwnProperty('answer')) {
        formData.append('answer', JSON.stringify(val.answer))
      }
      if (val.hasOwnProperty('role')) {
        formData.append('role', JSON.stringify(val.role))
      }
      if (val.hasOwnProperty('exampleTranslation')) {
        formData.append('exampleTranslation', JSON.stringify(val.exampleTranslation))
      }
      if (val.hasOwnProperty('exampleDictation')) {
        formData.append('exampleDictation', JSON.stringify(val.exampleDictation))
      }

      try {
        await postData('study-content', formData, { 
          headers : { 
            'Content-Type': 'multipart/form-data'
          }
        })
        this.$vs.notify({
          color: 'primary',
          title: '알림',
          text: '추가되었습니다.'
        })
        
        this.loadUnitContents()

      } catch (error) {
        
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }

      //this.$router.push('/content/content-list')
    }
  }
}

</script>
